<template>
  <el-card
    header="Reported Tracking Errors"
    shadow="never"
  >
    <div
      slot="header"
      class="clearfix"
    >
      <span>
        Reported Tracking Errors
      </span>
      <el-button-group style="float: right;">
        <el-popover
          placement="left-end"
          width="360"
        >
          <p>What is the issue? Eg. Wrong Info, No Tracking</p>
          <el-input
            v-model="errorMessage"
            type="text"
          />
          <div style="text-align: right; margin: 15px">
            <el-button
              type="primary"
              size="mini"
              @click.native="reportError"
            >
              Submit
            </el-button>
          </div>
          <el-button
            slot="reference"
            style="padding: 3px 0; color: red;"
            type="text"
          >
            Report Error
          </el-button>
        </el-popover>
      </el-button-group>
    </div>
    <el-table
      :data="errors"
      style="width: 100%"
    >
      <el-table-column
        prop="message"
        label="Error"
      />
      <el-table-column
        prop="profile.name_full"
        label="Reported By"
      />
      <el-table-column
        label="Created At"
        prop="created_at"
        :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
      />
    </el-table>
  </el-card>
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      errorMessage: ''
    }
  },
  methods: {
    async reportError () {
      this.$sdk.tracking_error_report.create({
        message: this.errorMessage,
        consignment: this.consignment,
        profile: await this.$user.instance
      }).then(res => {
        this.$message({ message: 'Tracking Error Reported', type: 'success' })
      })
    }
  }
}
</script>
